import { gql, QueryHookOptions } from '@apollo/client';
import { useMemo } from 'react';
import { useGraphql } from 'utils/hooks/useGraphql';

type QueryTemplateJsonTestDataVariables = {
  id: number;
  locale: {
    name: string;
  };
};

type QueryTemplateJsonTestDataResponse = {
  templateAndSingleContent: {
    templateId: number;
    dataFeedIds: number[];
    jsonTestData: {
      dataFeedJson: string;
      userJson: Record<string, any>;
      eventJson: Record<string, any>;
    };
  };
};

type QueryTemplateJsonTestDataOptions = QueryHookOptions<
  QueryTemplateJsonTestDataResponse,
  QueryTemplateJsonTestDataVariables
>;

export const queryTemplateJsonTestData = gql`
  query FetchTemplateSingleContentByIdQuery($id: Long!, $locale: TemplateLocaleInput) {
    templateAndSingleContent(id: $id, locale: $locale) {
      __typename
      ... on TemplateAndContent {
        templateId
        dataFeedIds
        jsonTestData {
          dataFeedJson
          userJson
          eventJson
        }
      }
    }
  }
`;

export const useQueryTemplateJsonTestData = (options: QueryTemplateJsonTestDataOptions = {}) => {
  const queryOptions = useMemo(() => {
    return {
      notifyOnNetworkStatusChange: true,
      ...options,
    };
  }, [options]);

  const {
    data,
    error: hasError,
    errorMessage,
    isLoading,
    refetch,
  } = useGraphql(queryTemplateJsonTestData, queryOptions);

  return {
    data,
    hasError,
    errorMessage,
    isLoading,
    refetch,
  };
};
